import axiosCrm from "@/utils/axios-instance";
import {
  TCallCenter,
  TCreateCallCenterPayload,
  TUpdateCallCenterPayload,
} from "@/models/call-centers.model";

export const getCallCenters = async (signal?: AbortSignal): Promise<TCallCenter[]> => {
  const response = await axiosCrm.get("/callcenter", { signal });
  return response.data;
};

export const getCallCenter = async (id: number, signal?: AbortSignal): Promise<TCallCenter> => {
  const response = await axiosCrm.get(`/callcenter/${id}`, { signal });
  return response.data;
};

export const createCallCenter = async (
  payload: TCreateCallCenterPayload
): Promise<TCallCenter> => {
  const response = await axiosCrm.post("/callcenter", payload);
  return response.data;
};

export const updateCallCenter = async (
  payload: TUpdateCallCenterPayload
): Promise<TCallCenter> => {
  const { id, ...data } = payload;
  const response = await axiosCrm.patch(`/callcenter/${id}`, data);
  return response.data;
};

export const deleteCallCenter = async (id: number): Promise<void> => {
  await axiosCrm.delete(`/callcenter/${id}`);
};
